module.exports = __webpack_public_path__ + "img/icon_job_03.9d56ef2e.svg";